<template>
  <div v-if="valid" class="ContentVideo"  :style="styles">
    <iframe v-if="youtube" width="500" height="281" :src="src" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen=""></iframe>
    <iframe v-if="vimeo" :src="src" width="640" height="360" frameborder="0" speed="false" loop="true"></iframe>
  </div>
</template>

<script>
export default {
  name: 'ContentVideo',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    youtube() {
      return this.content.source === 'youtube';
    },
    vimeo() {
      return this.content.source === 'vimeo';
    },
    queryString() {
      return '';
      // return '&start='+this.content.params.start; // doesn't work properly :S
    },
    styles() {
      return this.content.style;
    },
    src() {
      if (this.youtube) {
        return `https://www.youtube.com/embed/${this.content.code}?modestbranding=1&controls=0&showinfo=0&rel=0${this.queryString}&title=`
      }
      if (this.vimeo) {
        return `https://player.vimeo.com/video/${this.content.code}?color=2a914c&title=0`;
      }

      return null;
    },
    valid() {
      return this.src !== null;
    }
  }
}
</script>

<style lang="scss">
  .ContentVideo {
    margin-top: 1em;
    display: flex;
    justify-content: center;

    > * {
      max-height: 100%;
    }
  }

</style>
